import { createSelector } from 'reselect';

import { convertListToObjectBy } from 'utils/fn';
import { getBodyData } from 'store/selectors';

export const getOutofstockModal = (state) => getBodyData(state).outofstockModal || {};

export const getCatalogOutOfStockDetails = (state) =>
  getOutofstockModal(state).outOfStockProducts || {};
export const getCatalogOutOfStockProducts = (state) => getOutofstockModal(state).products || {};

/** popup out of stock */
export const getOutOfStockPopupState = (state) => getOutofstockModal(state).outOfStockOpenState;
export const getOutOfStockArticle = (state) => getOutofstockModal(state).article;
export const getOutOfStockPopupHeader = (state) => getOutofstockModal(state).header;
export const getOutOfStockAgreementState = (state, id) =>
  !!(getOutofstockModal(state).agreementUncheckedState || {})[id];
export const getOutOfStockStorageData = (state) => getOutofstockModal(state).storageData;
const getCatalogProductsListRaw = (state) => getOutofstockModal(state).list || [];
const getCatalogProductsDict = createSelector(
  getCatalogProductsListRaw,
  convertListToObjectBy('id'),
);
export const getOutOfStockProductId = (state) => getOutofstockModal(state).productId;
export const getOutOfStockIsSent = (state) => getOutofstockModal(state).isOutOfStockSent;
export const getOutOfStockProductArticle = createSelector(
  getCatalogProductsDict,
  getOutOfStockProductId,
  (dict, productId) => (dict[productId] || {}).article,
);
export const getOutOfStockPopupDescription = createSelector(
  getCatalogProductsDict,
  getOutOfStockProductId,
  (dict, productId) => (dict[productId] || {}).outOfStockMessageTemplate,
);
export const getOutOfStockView = (state) => getOutofstockModal(state).viewState;

export const getOutOfStockErrorFetchedText = (state) =>
  getOutofstockModal(state).errorFetchedMessage || 'Произошла ошибка отправки данных.';

/** backend data texts */
export const getCatalogOutOfStockTexts = (state) => getBodyData(state).outOfStock || {};
export const getOutOfStockSuccessText = (state) =>
  getCatalogOutOfStockTexts(state).successText ||
  '<OutOfStockHeading>Спасибо! </OutOfStockHeading>Как только товар появится, мы сразу уведомим Вас';
export const getOutOfStockErrorText = (state) =>
  getCatalogOutOfStockTexts(state).errorText ||
  'Произошла ошибка отправки данных. <ArticleReducer>Попробовать еще раз?</ArticleReducer>';
export const getOutOfStockAgreementDataText = (state) =>
  getCatalogOutOfStockTexts(state).agreementDataText ||
  'Я даю свое согласие на обработку <AgreementTextLink>персональных данных</AgreementTextLink>';
